export default __webpack_public_path__ + "static/media/starEmpty.738cbccf.svg";